const ThemePreferences = {
  dark: 'Dark',
  light: 'Light',
  system: 'Same as System'
};

export default ThemePreferences;
